import { render, staticRenderFns } from "./DeliveryManDetail.vue?vue&type=template&id=2c0f8c02&"
import script from "./DeliveryManDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryManDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports